export default "__VITE_ASSET__068e0066__"